<div class="modal modal-{{modalIndex}}">
    <div class="slide__text-inner">
        {{#if modal.text}}
        <div class="modal__slide-text">{{ modal.text }}</div>
        {{/if}}
        {{#if modal.type == 'Video'}}
        <button ref:button class="modal-button" on:click="open()"><span class="black-playhead"></span> Watch</button>
        {{elseif modal.type == 'About'}}
        <button ref:button class="about-button" on:click="open()">About this Project</button>
        {{else}}
        <button ref:button class="modal-button" on:click="open()"><span class="read-icon"></span>Read More</button>
        {{/if}}
    </div>
</div>

<div ref:overlay class="modal-wrapper modal-wrapper-{{modal.type}}">
    {{#if (modal.type == 'Note') || (modal.type == 'About')}}
        <div class="modal__note_wrapper">
            <div class="modal__note_wrapper-inner">
                {{#if modal.note_quote}}
                    <div class="modal__note_quote">
                        <div class="modal__note_quote-inner">
                            <p class="modal__note_quote-main">{{ modal.note_quote }}</p>
                            <p class="modal__note_quote-attribution">{{ modal.note_attribution }}</p>
                        </div>

                    </div>
                {{/if}}

                {{#if modal.note_list}}
                    <div class="modal__note_list-outer">
                        {{#each modal.note_list as note_item, n}}
                        <div class="modal__note_list modal__note_list--{{ n + 1 }}">
                            <p class="modal__note_list-inner">{{{ note_item }}}</p>
                        </div>
                        {{/each}}
                    </div>
                {{/if}}


                {{#if modal.note_section}}
                    <div class="modal__note_section-outer">
                        {{{ modal.note_section}}}
                    </div>
                {{/if}}

                {{#if modal.note_list_after}}
                    <div class="modal__note_list-outer modal__note_list_after-outer">
                        {{#each modal.note_list_after as note_item, n}}
                        <div class="modal__note_list modal__note_list_after modal__note_list--{{ n + 1 }}">
                            <p class="modal__note_list-inner modal__note_list_after-inner">{{{ note_item }}}</p>
                        </div>
                        {{/each}}
                    </div>
                {{/if}}
            </div>
        </div>
    {{/if}}
    {{#if modal.type == 'Video'}}
        <div class="modal__video-outer">
            <div class="modal__video-wrapper">
                <video ref:video bind:currentTime="t" bind:duration="d" bind:paused playsinline loop="{{ modal.loop }}">
                    {{#if modal.webm }}<source src="{{ video(modal.webm) }}" type="video/webm">{{/if}}
                    {{#if modal.mp4 }}<source src="{{ video(modal.mp4) }}" type="video/mp4">{{/if}}
                    {{#if modal.vtt }}
                    <track ref:track label="English captions" src="{{ modal.vtt }}" kind="metadata" srclang="en" default>
                    {{/if}}
                </video>
                <Progress ref:progress :t :d :paused on:toggle="toggle()" />
            </div>
            {{#if modal.caption}}
            <div class="modal__caption">{{ modal.caption }}</div>
            {{/if}}
        </div>
    {{/if}}
</div>

<script>
import Progress from './video/Progress.html'
import tingle from 'tingle.js'
import { setHintTimeout, video, noop } from './helpers'

export default {

    components: {
        Progress,
    },

    data() {
        return {
            t: 0,
            d: 0,
            cues: [],
            paused: true
        }
    },

    oncreate () {
        this.observers = [];

        const {video, track, display, overlay} = this.refs;

        this.closeModal = false;

        if (track) {
            track.addEventListener('cuechange', e => {
                display.set({ cues: e.target.track.activeCues });
            }, false);
        }

        if (video) {
            this.observers.push(this.store.observe('muted', muted => {
                video.muted = muted;
            }, { defer: true }));
        }

        let custom_class = [ `modal-${this.get('modal').slug}`, `modal-${this.get('modal').type}` ];

        //let self = this;

        // instantiate new modal
        this.modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: "Done",
            cssClass: custom_class,
            onOpen: () => {
                this.store.set({ modal_active: true });
                this.modalListener = this.store.observe('current_slide', current => {
                    if( this.get('slideIndex') !== current ) this.modal.close();
                });

                if (video) this.play();
            },
            onClose: () => {
                this.store.set({ modal_active: false });
                this.modalListener.cancel();
                if (video) this.pause();
                this.closeModal = false;
                if ( this.get('modal').type == 'Video' ) setHintTimeout(this.store.get('scroll_hint_delay'));
            },
            beforeClose: () => {
                // modal close animation
                if (!this.closeModal) {
                    document.body.classList.add("tingle-closing");
                    setTimeout(() => {
                        //document.body.className = document.body.className.replace("tingle-closing","");
                        document.body.classList.remove('tingle-closing');
                        this.closeModal = true;
                        this.modal.close();
                    }, 1200);
                    return false;
                }
                return true; 
            }
        });

        this.modal.setContent(overlay);

    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel();
        }
    },

    methods: {
        toggle() {
            const {video} = this.refs;
            if (video.paused) {
                this.play();
            } else {
                this.pause();
            }
        },

        play() {
            this.refs.video.play().catch(noop);
        },

        pause() {
            this.refs.video.pause();
        },

        open() {
            let buttonOpacity = window.getComputedStyle(this.refs.button,null).getPropertyValue("opacity");
            if (buttonOpacity > 0 && this.closeModal == false) this.modal.open();
        }
    },

    helpers: {
        video,
    }
}
</script>